import {
  Component,
  Input,
  SimpleChanges,
  ViewChild,
  OnDestroy,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DashboardComponent } from '../../../pages/dashboard/dashboard.component';
import { DashboardService, StaffMenuItem } from '../../../pages/dashboard/dashboard.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../sidenav-content';

@Component({
  selector: 'staff-menu',
  templateUrl: './staff-menu.component.html',
  styleUrls: ['./staff-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StaffMenuComponent extends SidenavContent implements OnInit, OnChanges, OnDestroy {
  @Input() menu: any;
  @ViewChild('dashboard') dashboard: DashboardComponent;
  staffMenuItems: StaffMenuItem[] = [];

  private _unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private _dashboardService: DashboardService,
    private _layoutService: LayoutService,
  ) {
    super(_layoutService);
  }

  ngOnInit() {
    this._dashboardService.staffDashboardMenu$
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((staffMenus) => {
        this.staffMenuItems = staffMenus.map((m) => {
          const clone = { ...m };
          clone.expanded = false;
          return clone;
        });

        const menu = this.staffMenuItems.find((m) => m.menuId == this.menu.menuId);
        this.toggleMenu(menu);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.menu && this.staffMenuItems) {
      this.staffMenuItems.forEach((m) => (m.expanded = false));
      const menu = this.staffMenuItems.find((m) => m.menuId == this.menu.menuId);
      // TODO: If a page is loaded directly, and not accessed through the dashboard, the staffMenuItems may not be available yet.
      if (menu) {
        this.toggleMenu(menu);
      }
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  openStaffIframe(menuItem: number): void {
    this._dashboardService.goToMenuItem(menuItem);
    this.closeNav();
  }

  toggleMenu(menu) {
    menu.expanded = !menu.expanded;
  }
}
